import gql from 'graphql-tag';
import FieldsDepartment from "graphql/fields/FieldsDepartment";
import FieldsCompany from 'graphql/fields/FieldsCompany'

import HelperGraphql from 'utils/helper-graphql'

const fields = {
	'guid': 'String!',
};

export default gql(`
	query department( ${ HelperGraphql.createFields( fields ) } ) {
		department( ${ HelperGraphql.createVariables( fields ) } ) {
			${ FieldsDepartment }
			
			company {
				${ FieldsCompany }
			}
		}
	}
`);
